import { Bet } from "@/modules/report/slice/betRecord";
import CircleIcon from '@mui/icons-material/Circle';
import Grid from "@mui/material/Grid";
import Stack from '@mui/material/Stack';
import Typography from "@mui/material/Typography";

type SedieGameResultRecordPanelProps = {
    bet: Bet;
};
export const SedieGameResultRecordPanel = (
    props: SedieGameResultRecordPanelProps
) => {
    const { bet } = props;

    const getPattern = () => {
        let colors = [];
        switch (bet.Result) {
            default:
            case '0':
                colors = ['white', 'white', 'white', 'white'];
                break;
            case '1':
                colors = ['white', 'white', 'white', '#C1281B'];
                break;
            case '2':
                colors = ['white', 'white', '#C1281B', '#C1281B'];
                break;
            case '3':
                colors = ['white', '#C1281B', '#C1281B', '#C1281B'];
                break;
            case '4':
                colors = ['#C1281B', '#C1281B', '#C1281B', '#C1281B'];
                break;
        }

        const getTextColor = () =>{
            return colors[3] === '#C1281B'? 'white':'#C1281B';
        }

        return (
            <Stack direction={'row'} spacing={1} className="game-result">
                <Grid container className="grid">
                    <CircleIcon fontSize="large" style={{ color:colors[0] }}/>
                </Grid>
                <Grid container className="grid">
                    <CircleIcon fontSize="large" style={{ color:colors[1] }}/>
                </Grid>
                <Grid container className="grid">
                    <CircleIcon fontSize="large" style={{ color:colors[2] }}/>
                </Grid>
                <Grid container className="grid">
                    <CircleIcon fontSize="large" style={{ color:colors[3] }}/>
                    <Typography className="grid-text" style={{ color:getTextColor() }}>{bet.Result}</Typography>
                </Grid>
            </Stack>
        )
    };

    return (
        <>
            <Stack className="item-sedie-game-result-container" justifyContent="center">
                {getPattern()}
            </Stack>
        </>
    );
};
